export const DOWNLOADING = 'Downloading';
export const DOWNLOADED = 'Downloaded';
export const RUNNING = 'Running';
